"use client";
import { useEffect, useState } from "react";

import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";

import { PrimNavigationMenu } from "@/shared-web.ui/prim.navigation-menu";
import { cn } from "@/shared-web.ui/util.cn";

const { navigationMenuTriggerStyle } = PrimNavigationMenu;

interface DesktopSwitchProps {
  color?: "accent" | "gray";
}
const DesktopSwitch = (props: DesktopSwitchProps) => {
  const { color = "accent" } = props;

  // without these mounted setting,
  // component will cause `Hydration failed because the initial UI does not match what was rendered on the server`
  const [mounted, setMounted] = useState(false);

  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <button
      className={cn(
        navigationMenuTriggerStyle({ color }),
        "px-2",
      )}
      onClick={toggleTheme}
      type="button"
    >
      {theme === "dark"
        ? <MoonIcon className="text-gray-9 size-5" />
        : (
            <SunIcon className="text-gray-9 size-5" />
          )}
    </button>
  );
};

export { DesktopSwitch };
